import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast, Toaster } from "sonner";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { Switch } from "../components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../components/ui/alert-dialog";
import { Plus, Pencil, Trash2, Users } from "lucide-react";

export default function Teachers() {
  const [teachers, setTeachers] = useState([]);
  const [dialog, setDialog] = useState(null);
  const [delTarget, setDelTarget] = useState(null);
  const [form, setForm] = useState({ name: "", is_staff: false, active: true });

  const load = () => api.get("/teachers").then((r) => setTeachers(r.data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ name: "", is_staff: false, active: true }); setDialog("new"); };
  const openEdit = (t) => { setForm({ ...t }); setDialog(t.id); };

  const save = async () => {
    try {
      if (dialog === "new") await api.post("/teachers", form);
      else await api.put(`/teachers/${dialog}`, form);
      toast.success("Data guru tersimpan");
      setDialog(null); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal menyimpan"); }
  };

  const doDelete = async () => {
    try {
      await api.delete(`/teachers/${delTarget.id}`);
      toast.success("Guru dinonaktifkan"); setDelTarget(null); load();
    } catch (e) { toast.error("Gagal"); }
  };

  return (
    <div className="space-y-5" data-testid="teachers-page">
      <Toaster position="top-center" richColors />
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-nunito font-extrabold text-2xl text-gtsnavy">Data Guru dan Staf</h2>
          <p className="text-sm text-muted-foreground">Kelola daftar guru dan staf</p>
        </div>
        <Button onClick={openNew} className="rounded-full bg-gradient-to-r from-gtsorange to-gtsorange-light text-white gap-1" data-testid="add-teacher-btn">
          <Plus className="w-4 h-4" /> Tambah
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {teachers.map((t) => (
          <Card key={t.id} className="rounded-2xl border-none shadow-[0_8px_30px_rgb(16,42,86,0.06)] p-5 bg-white" data-testid={`teacher-card-${t.id}`}>
            <div className="flex items-start gap-3">
              <div className="w-11 h-11 rounded-2xl bg-gtsnavy/10 flex items-center justify-center text-gtsnavy font-bold shrink-0">
                {t.name.replace(/^(Mr\.|Ms\.)\s*/, "").charAt(0)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gtsnavy truncate">{t.name}</p>
                <Badge className={`mt-1 rounded-full ${t.is_staff ? "bg-gtsnavy/10 text-gtsnavy" : "bg-orange-100 text-gtsorange"}`}>
                  {t.is_staff ? "Staf (Admin Fee)" : "Guru"}
                </Badge>
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              <Button size="sm" variant="outline" onClick={() => openEdit(t)} className="rounded-full flex-1 gap-1" data-testid={`edit-teacher-${t.id}`}>
                <Pencil className="w-3.5 h-3.5" /> Edit
              </Button>
              <Button size="sm" variant="outline" onClick={() => setDelTarget(t)} className="rounded-full text-rose-600 border-rose-200" data-testid={`delete-teacher-${t.id}`}>
                <Trash2 className="w-3.5 h-3.5" />
              </Button>
            </div>
          </Card>
        ))}
      </div>

      <Dialog open={!!dialog} onOpenChange={(o) => !o && setDialog(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>{dialog === "new" ? "Tambah Guru/Staf" : "Edit Guru/Staf"}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nama</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-xl mt-1" placeholder="Mr. / Ms. Nama" data-testid="teacher-name-input" />
            </div>
            <div className="flex items-center justify-between rounded-xl border p-3">
              <div>
                <p className="text-sm font-medium">Staf (Administration Fee)</p>
                <p className="text-xs text-muted-foreground">Tidak masuk tabel absensi</p>
              </div>
              <Switch checked={form.is_staff} onCheckedChange={(v) => setForm({ ...form, is_staff: v })} data-testid="teacher-staff-switch" />
            </div>
          </div>
          <DialogFooter><Button onClick={save} className="rounded-full bg-gtsnavy text-white" data-testid="save-teacher-btn">Simpan</Button></DialogFooter>
        </DialogContent>
      </Dialog>

      <AlertDialog open={!!delTarget} onOpenChange={(o) => !o && setDelTarget(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Nonaktifkan {delTarget?.name}?</AlertDialogTitle>
            <AlertDialogDescription>Data tidak dihapus permanen (soft delete) dan bisa dipulihkan.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Batal</AlertDialogCancel>
            <AlertDialogAction onClick={doDelete} className="bg-rose-500" data-testid="confirm-delete-teacher">Nonaktifkan</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
